import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './theme/pages/dashboard/dashboard.component';
import { ActiveUserGuard } from 'src/app/guards/active-user/active-user.guard';
import { LayoutComponent } from 'src/app/theme/layout/layout.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [ActiveUserGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: '**', redirectTo: '/perfil/dashboard', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRouting {}
